/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Session_Expirederror1Inputs */

const en_common_session_expirederror1 = /** @type {(inputs: Common_Session_Expirederror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Please sign in again.`)
};

/**
* | output |
* | --- |
* | "Your session expired. Please sign in again." |
*
* @param {Common_Session_Expirederror1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_session_expirederror1 = /** @type {((inputs?: Common_Session_Expirederror1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Session_Expirederror1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_session_expirederror1(inputs)
});
export { common_session_expirederror1 as "common.session.expiredError" }